import { Avatar, Box, Modal, Stack, Typography } from '@mui/material'
import { Fade } from 'utoniq-ui'

import { ItemThumbnailType } from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'
import { CellFrame } from '@/core/architecture'
import { individualHideGachaRemainingItemCount } from '@/core/individual'

import { RewardItemWithFistTimeObtainedRare } from '.'
import { getEmphasisRaritySx } from './LightFrame'

type RareItemModalProps = {
  rewardItem: RewardItemWithFistTimeObtainedRare
  open: boolean
}
/**
 * @description
 * 初めて手に入れたレアアイテムを拡大表示する用のコンポーネント
 */
export const RareItemModal = ({ rewardItem, open }: RareItemModalProps) => {
  const { t } = useTranslation('gachaResult')

  const { userItem, item } = rewardItem

  return (
    <Modal open={open} sx={{ bgcolor: 'background.default' }}>
      <CellFrame
        sx={{
          display: 'flex',
          flexDirection: 'column',
          pt: 2,
          pb: 3,
          px: 5,
          height: '100%',
        }}
      >
        <Stack
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          flex={1}
        >
          <Fade>
            <>
              <Box
                sx={{
                  position: 'absolute',
                  zIndex: 0,
                  width: 220,
                  height:
                    item.thumbnailType === ItemThumbnailType.Square ? 220 : 352,
                  ...getEmphasisRaritySx(item.rarity?.id, 50),
                }}
              />
              <Avatar
                variant="square"
                src={item.thumbnail.front?.mediumUri ?? ''}
                sx={{
                  width: 220,
                  height:
                    item.thumbnailType === ItemThumbnailType.Square ? 220 : 352,
                  borderRadius: 1,
                }}
              />
            </>
          </Fade>

          <Stack
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
            sx={{ pt: 5, textAlign: 'center' }}
          >
            <Typography variant="h5" sx={{ mr: 1 }}>
              {item.title}
            </Typography>
            {/**
             * @todo
             * 現状のAPIだと出たアイテム自体のformattedSerialNumberが取得できないので、API改修後実装
             * https://app.clickup.com/t/908127/UT-4730
             */
            /*<SerialNumber label={userItem.formattedSerialNumber}></SerialNumber>*/}
          </Stack>

          <Stack
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
            sx={{ pt: 2, textAlign: 'center' }}
          >
            {item?.rarity && (
              <>
                <Typography variant="overline" sx={{ mr: 1 }}>
                  {t('rarity')}
                </Typography>
                <Avatar
                  variant="square"
                  src={item?.rarityIconImage?.smallUri ?? ''}
                  sx={{
                    height: 20,
                    width: 'fit-content',
                    mr: 1,
                  }}
                />
                <Typography variant="overline" color="text.hint" sx={{ mr: 4 }}>
                  {item?.rarity?.name}
                </Typography>
              </>
            )}

            <Typography variant="overline" color="text.hint" sx={{ mr: 2 }}>
              {t('numberOfPossessions')}
            </Typography>
            <Typography variant="overline">
              {userItem.number}
              {individualHideGachaRemainingItemCount()
                ? t('possessionUnit')
                : ` / ${item.issuedNumber ?? '∞'}`}
            </Typography>
          </Stack>
        </Stack>
      </CellFrame>
    </Modal>
  )
}
